export const MetaDataType = {
  flight: 0,
  publicTransport: 1,
  rawHubData: 2,
  rawFlightData: 3,
  flightInfo: 4,
  bookFeedback: 5,
  cancelFeedback: 6,
  additionalServices: 7,
};
